import { ROLES } from 'src/types/Employee';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';
import { getRolesOptions } from 'src/components/enterprise/features/Employee/components/Form/controls/PermissionsControlWrapper/PermissionsControl.utils';
import { ROLES_OPTION } from 'src/components/enterprise/features/Employee/utils/employeeRoles.utils';

type UsePermissionsControlWrapper = {
  isPermissionsEditable: boolean;
  filterOptions: (options: ROLES_OPTION[]) => ROLES_OPTION[];
};

export function usePermissionsControlWrapper(): UsePermissionsControlWrapper {
  const { isInternalAdminUser, isEditPage, employeeData } =
    useEmployeeFormContext();

  const isPermissionsEditable =
    !isEditPage ||
    isInternalAdminUser ||
    employeeData?.role !== ROLES.FINANCIAL_ADMIN;

  const filterOptions = (options: ROLES_OPTION[]): ROLES_OPTION[] => {
    return getRolesOptions(
      options,
      isInternalAdminUser,
      !isPermissionsEditable
    );
  };

  return {
    filterOptions,
    isPermissionsEditable,
  };
}
